import React from 'react';
import { statusColor } from '../utils/helpers';
export default function StatusBadge({ status }) {
  const { color, bg } = statusColor(status);
  return <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500, background: bg, color, whiteSpace: 'nowrap' }}>{status}</span>;
}
